import React from 'react';

import { ArchivalUnitReservation } from 'types';
import { PageKey, SortOrder } from 'enums';

import { LentTable } from './lent-table';
import { fetchTableItems } from './lent-api';
import { lentPhysicalColumns } from './lent-columns';

const fetchFunction = fetchTableItems<ArchivalUnitReservation>(
  '/api/archival-unit/reservation/my-ready-reservations'
);

export function LentTablePhysical() {
  return (
    <LentTable<ArchivalUnitReservation>
      title="Papírové archiválie připravené v badatelně AUK"
      pageKey={PageKey.PORTFOLIO_LENT_PHYSICAL}
      columns={lentPhysicalColumns}
      fetchFunction={fetchFunction}
      params={{
        sort: [
          { field: 'archivalUnitReference.numericId', order: SortOrder.ASC },
        ],
      }}
    />
  );
}
